<template>
  <div class="animated fadeIn list-of-ib">
    <b-card>
      <div slot="header">Internal Budget (Turunan dari Master Budget)
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <!-- <b-button variant="primary mr-1" @click="deleteConfirm" :disabled="disabledDelete">Delete</b-button> -->
          <b-button variant="primary mr-1" @click="deleteConfirm" >Delete</b-button>
          <b-button variant="primary mr-1" @click="closeVoidConfirm">Close/Void</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="progress()"><i class="fa fa-hourglass-half"></i> Progress</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col md="6">
              <b-row>
                <b-col  lg="5">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">No. Internal Budget &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Budget No."></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="7">
                  <b-input-group >
                      <b-input-group-prepend><span class="p-2">Name,Note/Remark</span ></b-input-group-prepend>
                      <b-form-input v-model="tblData.uraian" ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>                      

            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col md="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Production Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Status &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.status" :plain="true" :options="approvalStatus"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>            
            <b-input-group >
              <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
              <b-form-input v-model="tblData.customer" placeholder="Customer Name"></b-form-input>
              <b-form-input v-model="tblData.cust_po" placeholder="Customer Order No." class="ml-1"></b-form-input>
              <b-input-group-append>
                    <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
              </b-input-group-append>
              <b-input-group-append>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#"  style="padding:0 !important;">Print</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" style="padding:0 !important;">Approval</b-dropdown-item>
          <b-dropdown-item @click="rowProgress(data.item)" href="#" style="padding:0 !important;">Progress</b-dropdown-item>
          <b-dropdown-item @click="rowVoid(data.item)" href="#" style="padding:0 !important;">Close/Void</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
          <b-dropdown-item @click="rowAttachment(data.item)" href="#"  style="padding:0 !important;">Attachment</b-dropdown-item>
        </b-dropdown>
      </template>          
        <template v-slot:cell(ibtanggal)="data">
          {{ data.item.ibtanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(requstart)="data">
          {{ data.item.requstart | moment("DDMMMYYYY") }} - {{ data.item.requend | moment("DDMMMYYYY") }}
        </template>
        <template v-slot:cell(noprodintern)="data">
          <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; width:100px !important;">
          {{ data.item.noprodintern }}</div>
        </template>
        
        <template v-slot:cell(issuccess)="data">
          <div v-if="data.item.send2wf==0" style="background-color:yellow;">           
            DRAFT
          </div>
          <div v-else> 
            <div v-if="data.item.iscomplete==0">           
              ON PROCESS
            </div>
            <div v-else>           
                <div v-if="data.item.issuccess==1"  style="background-color:#04f681;">           
                  APPROVED
                </div>
                <div v-else style="background-color:#f86c6b;">           
                  REJECTED
                </div>
            </div>
          </div>
        </template>

        <template v-slot:cell(ibbudgettotal)="data">
          {{data.item.ibbudgettotal | numFormat}}
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Budget Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="7">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Budget Date</label></b-input-group-prepend>
                     <b-input-group-append ><label class="input-group-text">
                          {{ model.startdate | moment("DDMMMYYYY") }} - {{ model.finishdate | moment("DDMMMYYYY") }}                       
                       </label></b-input-group-append>                    
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-row>
              <b-col md="9">
                  <b-input-group >
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                      <b-form-input v-model="model.uraian"  placeholder="Budget Description" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="3">
                  <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.sales" disabled class="mt-1">Budget Sales/Project</b-form-checkbox>
              </b-col>
          </b-row>    
          <b-row>
              <b-col md="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Internal Budget</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomorintern" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="7">                            
                  <b-input-group>
                      <b-input-group-prepend><label>No. Product/Eps</label></b-input-group-prepend>
                      <b-form-input v-model="model.noprodintern"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0) || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <!-- <b-button variant="danger" class="ml-1" v-if="(model.iscomplete==0)" @click="console.log('cancel approval')" > <i class="fa fa-undo"></i> Cancel Approval</b-button> -->
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showCloseVoidConfirm" header-bg-variant="primary"  title="Close / Void - Form" size="lg" :centered="true" @ok="closeVoidProcess" ok-title="Save">
              <b-row>
                  <b-col lg="6" xl="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Internal Budget Number</label></b-input-group-prepend>
                      <b-form-input v-model="closeVoidData.nomorintern" readonly></b-form-input>
                  </b-input-group>
                  </b-col>
                  <b-col lg="6" xl="5">                            
                  <b-input-group>
                      <b-input-group-append><span class="input-group-text">Created By</span></b-input-group-append>
                      <b-form-input v-model="closeVoidData.createby" readonly></b-form-input>                                        
                  </b-input-group>
                  </b-col>
              </b-row >    
            <b-input-group>
                <b-input-group-prepend><label>Remark</label></b-input-group-prepend>
                <b-form-input v-model="closeVoidData.remark" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Close/Void Reasone</label></b-input-group-prepend>
                <b-form-textarea :rows="3" :max-rows="3" v-model="closeVoidData.closevoidnote" :state="!$v.closeVoidData.closevoidnote.$error" ></b-form-textarea>
            </b-input-group>
      </b-modal>
      <b-modal
        v-model="showAttachment"
        header-bg-variant="primary"
        title="Attachment"
        size="lg"
        :centered="true"
        ok-only
      >
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>Internal Budget#</label></b-input-group-prepend
              >
              <b-form-input v-model="model.nomorintern" readonly></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <div class="report-wraper">
          <table width="100%">
            <thead>
              <tr>
                <th width="200px">Attached Date</th>
                <th>File Name</th>
                <th width="100px">Attached By</th>
                <th width="40px">action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in attachmens" :key="row.attachmentKey">
                <td>
                  {{ row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
                </td>
                <td>
                  <b-link @click="attachmentDownload(row)">{{
                    row.attchFileNm
                  }}</b-link>
                </td>
                <td>{{ row.createby }}</td>
                <td>
                  <div class="text-center" v-if="model.iscomplete == 0">
                    <a
                      href="javascript:void(0)"
                      class="text-danger"
                      @click="delAttachment(row)"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div no-body v-if="model.iscomplete == 0">
          <label>Add Attachment</label>
          <b-form-file
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <b-row class="mt-1" v-if="file">
            <span class="p-2"
              >Selected File:
              <strong>{{ file ? file.name : "" }}</strong> Filesize:{{
                bytesToKB.showFileSize(file)
              }}</span
            >
            <b-button
              variant="success"
              @click="attachmentSave"
              class="sm"
              ><i class="fa fa-paperclip"></i> Add Attachment</b-button
            >
          </b-row>
        </div>
      </b-modal>

  </div>
</template>

<style lang="scss">
  .list-of-ib {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
     }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import budgetinternal from "../../apis/budgetinternal";
import task from "../../apis/task";
import dropdown from "../../data/dropdown";
import bytesToKB from "../../libs/filesize-byte2kb";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {Loading},
  mixins: [validationMixin],
  validations: {
        closeVoidData: {
            closevoidnote: { required },
        },
  }, 
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showCloseVoidConfirm:false,
      closeVoidData:{
        closeVoid:'closed',
        closevoidnote:'', isclosed:1
      },
      showApprovalConfirm: false,
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,
      approvalHistory:[],    
      approvalStatus : dropdown.approvalStatus,
      showAttachment: false,
      attachmens: [],
      bytesToKB,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        status:"",
        postgroup:"",
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment().format('YYYY-MM-DD'),
      // tgl2:this.$store.state.user.akhirbln,        
        sortBy: 'nomorintern',
        sortDesc: true,
        DimCol:'Dim1',
        outstand:''
      },
      items:[],
      model:{},
      postGroups:[],
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },         
        {
            key: "nomorintern",
            thStyle: "width:120px",
            label: "Internal Budget#",
            sortable: true
          },
          {
            key: "ibtanggal",
            thStyle: "width:90px",
            label: "Create Date",
            sortable: true
          },
          {
            key: "uraian",
            thStyle: "width:300px",
            label: "Budget Name",
            sortable: true
          },
          {
            key: "noprodintern",
            label: "No. Produk/Eps.",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "remark",
            label: "Note/Remark",
          },
          {
            key: "requstart",
            thStyle: "width:100px",
            label: "Production Date",
            sortable: true
          },
          {
            key: "ibbudgettotal",
            label: "Internal Budget Amount",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "createby",
            thStyle: "width:90px",
            label: "Create By",
            sortable: true
          },
          {
            key: "issuccess",
            thStyle: "width:120px",
            label: "Approval Status",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    invalidCloseVoidData() {
      this.$v.closeVoidData.$touch();
      return this.$v.closeVoidData.$invalid;
    },
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  // created: async function(){
  //       const now = new Date();
  //       const tgl1 = moment(now).startOf('month').format('YYYY-MM-DD');
  //       const tgl2 = moment(now).endOf('month').format('YYYY-MM-DD');
  //       this.tblData.tgl1=this.tblData.tgl1 || tgl1;
  //       this.tblData.tgl2=this.tblData.tgl2 || tgl2;
  // },  
  methods: {
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    // },
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.iblist) {
            this.tblData[key] = filter.iblist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.iblist.tgl1 || '';
          this.tblData.tgl2=filter.iblist.tgl2 || '';
          this.showFilter=filtered;
          delete filter.iblist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await budgetinternal.list(this.tblData);   
      this.items = list ;
      this.isLoading=false;

      return list;
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },    
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.customer=  '';
        this.tblData.cust_po=  '';
        this.tblData.status=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';

    },
    saveFilter() {
      const keys = ['uraian', 'nomor', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'customer', 'cust_po', 'status'];
      let filtered = false;
      const iblist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              iblist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          iblist.page=this.tblData.page;
          iblist.limit=this.tblData.limit;
          iblist.sortBy=this.tblData.sortBy;
          iblist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.iblist=iblist;
          this.$store.commit("filter", filter);
      }
    },    

    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowProgress(record) {
      this.rowClicked(record);
        this.progress();        
    },
    rowVoid(record) {
      this.rowClicked(record);
      this.closeVoidConfirm();

    },    
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },    
    rowAttachment(record) {
      this.model = record;
      this.getAttachment(record);
    },
    getAttachment: async function (record) {
      try {
        this.model = record;
        this.isLoading = true;
        const data = await task.getAttachment({ taskkey: record.ibudghdkey });
        this.attachmens = data;
        this.showAttachment = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    attachmentSave: async function (evt) {
      evt.preventDefault();
      if (!this.file) {
        toastr.error("Please choose a file");
      } else {
        toastr.info(`Attachment Save`);
        this.isLoading = true;
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          formData.append("filename", this.file.name);
          formData.append("tablekey", this.model.ibudghdkey);
          formData.append("tableName", "project_budget_header_internal");
          formData.append("filesize", bytesToKB.showFileSize(this.file));
          const response = await task.attachmentSave(formData);
          console.log("response : ", response);
          const data = await task.getAttachment({
            taskkey: this.model.ibudghdkey,
          });
          this.attachmens = data;
          this.file = null;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    attachmentDownload: async function (fl) {
      this.isLoading = true;
      try {
        await task.attachmentDownload(fl);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    delAttachment: async function (obj) {
      const pesan = `Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal
        .msgBoxConfirm(pesan, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value == true) {
            this.isLoading = true;
            try {
              await task.delAttachment(obj);
              const data = await task.getAttachment({
                taskkey: this.model.ibudghdkey,
              });
              this.attachmens = data;
              this.isLoading = false;
            } catch (error) {
              this.isLoading = false;
              console.log("error : ", error);
              if (error.sql) {
                toastr.error(error.sql, "ERROR MESSAGE", 10000);
              } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
              } else if (error.message) {
                toastr.error(error.message, "ERROR MESSAGE", 10000);
              } else {
                toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
              }
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    add(){
      this.saveFilter();
          router.push({name :'budget.internbudgetfrm'});
    },
    closeVoidConfirm() {
        if (this.model.ibudghdkey) {
          this.showCloseVoidConfirm = true;
          for (const key in this.model) {
            if (this.model.hasOwnProperty(key)) {
              this.closeVoidData[key] = this.model[key];
            }
          }
        } else {
            toastr.warn('Please select a row that want to be Closed / Void!');
        }
    },
    closeVoidProcess:async function(evt) {
      evt.preventDefault()
      if (this.invalidCloseVoidData) {
          console.log('validation : ', this.$v.model);
          console.log('model obj : ',this.model);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
        this.closeVoidData.isclosed = 1;
        await budgetinternal.closevoid(this.closeVoidData);
        this.refresh();
      }
    },
    edit: function() {
        if (this.model.ibudghdkey) {
          this.saveFilter();
          router.push({name :'budget.internbudgetfrm', params: { ibudghdkey: this.model.ibudghdkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.ibudghdkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await budgetinternal.remove(this.model);
        // const index= this.items.findIndex(r => (r.ibudghdkey==this.model.ibudghdkey));
        // this.items.splice(index, 1);
        this.isLoading=false;
        this.refresh();
      } catch (error) {
        this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    rowClicked(record, index) {
      if( record.status === '111' ){
        this.disabledDelete = true;
        this.disabledCloseVoid   = false;
      }else{
        this.disabledDelete = false;
        this.disabledCloseVoid   = true;
      }

      // if (this.model.pjxhdrkey == record.pjxhdrkey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    approvalConfirm: async function () {
        if (this.model.ibudghdkey) {
            if (this.model.send2wf==1) {
              try {
                const data = await task.approvalhistory({key: this.model.ibudghdkey});
                this.approvalHistory=data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                
              }
            }
            this.showApprovalConfirm = true;
            this.model.ibtanggal = this.model.ibtanggal ? moment(this.model.ibtanggal).format('YYYY-MM-DD') : '';

        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    print: async function()
    {
      if (this.model.ibudghdkey) {
          try {
                this.showReport=true;
              this.reportUrl= await budgetinternal.print(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.ibudghdkey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await budgetinternal.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await budgetinternal.approvalUndo(this.model);
            this.model.approvalConfirm=false;
            this.model.send2wf=0;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.ibudghdkey) {
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.ibudghdkey});
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },    
    progress: async function()
    {
        if (this.model.ibudghdkey) {
          // if ((this.model.iscomplete==1) && (this.model.issuccess==1)) {
              const filter = this.$store.state.filter;
              filter.iblist=this.tblData;
              this.$store.commit("filter", filter);
              router.push({name :'budget.progressinterbudget', params: { ibudghdkey: this.model.ibudghdkey}});
          // } else {
          //   toastr.warn('Approval in Progress, no transaction/requesition for the budget !');
          // }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },    
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await budgetinternal.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
        // router.push({name:'budgetinternalment.home'});
          router.push("home");
    }

  }
};
</script>
